export enum PermissionsEnum {
  UsersCreate = 'users_create',
  UsersView = 'users_view',
  UsersEdit = 'users_edit',
  UsersDelete = 'users_delete',

  GroupCreate = 'groups_create_Groups',
  GroupView = 'groups_view_Groups',
  GroupEdit = 'groups_edit_Groups',
  GroupDelete = 'groups_delete_Groups',

  RolesCreate = 'roles_create',
  RolesView = 'roles_view',
  RolesEdit = 'roles_edit',
  RolesDelete = 'roles_delete',

  OrganisationCreate = 'organisation_create',
  OrganisationView = 'organisation_view',
  OrganisationEdit = 'organisation_edit',
  OrganisationDelete = 'organisation_delete',

  TransactionCreate = 'transaction_create',
  TransactionView = 'transaction_view',
  TransactionEdit = 'transaction_edit',
  TransactionDelete = 'transaction_delete',

  LoanCreate = 'loan_create',
  LoanView = 'loan_view',
  LoanEdit = 'loan_edit',
  LoanDelete = 'loan_delete',
  LoanInitiateCollection = 'loan_Initiate_Collection',

  LoanScheduleCreate = 'loanschedule_create',
  LoanScheduleEdit = 'loanschedule_edit',
  LoanScheduleView = 'loanschedule_view',
  LoanScheduleDelete = 'loanschedule_delete',

  MidaXCreate = 'midax_create_midaX',
  MidaXEdit = 'midax_edit_midaX',
  MidaXView = 'midax_view_midaX',
  MidaXDelete = 'midax_delete_midaX',

  BillingCreate = 'billing & settlement_create_Billing & Settlement',
  BillingEdit = 'billing & settlement_edit_Billing & Settlement',
  BillingView = 'billing & settlement_view_Billing & Settlement',
  BillingDelete = 'billing & settlement_delete_Billing & Settlement',

  WalletCreate = 'wallet_create_Wallet',
  WalletView = 'wallet_view_Wallet',
  WalletEdit = 'wallet_edit_Wallet',
  WalletDelete = 'wallet_delete_Wallet',

  WebhooksCreate = 'webhooks_create_Webhooks',
  WebhooksView = 'webhooks_view_Webhooks',
  WebhooksEdit = 'webhooks_edit_Webhooks',
  WebhooksDelete = 'webhooks_delete_Webhooks',
}
